/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Create_Card_TitleInputs */

const en_admin_categories_create_card_title = /** @type {(inputs: Admin_Categories_Create_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new event`)
};

const de_admin_categories_create_card_title = /** @type {(inputs: Admin_Categories_Create_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Veranstaltung anlegen`)
};

/**
* | output |
* | --- |
* | "Create new event" |
*
* @param {Admin_Categories_Create_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_categories_create_card_title = /** @type {((inputs?: Admin_Categories_Create_Card_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Create_Card_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_categories_create_card_title(inputs)
	return en_admin_categories_create_card_title(inputs)
});